import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/other/horizontal-scroll.module.css";

export default {
  "scroll": "horizontal-scroll-module__scroll_iOq7QG__100",
  "scrollWrapper": "horizontal-scroll-module__scrollWrapper_iOq7QG__100"
};
      